import { fmt, fmtChg, fmtPct, fmtQty, fmtTime, tone, slug } from "@/lib/format";
import { LtpCell } from "./LtpCell";
import { StatusBadge } from "./StatusBadge";

const TH = ({ children, right }) => (
  <th className={`whitespace-nowrap px-3 py-2 text-[10px] font-semibold uppercase tracking-wider text-slate-500 ${right ? "text-right" : "text-left"}`}>
    {children}
  </th>
);

export const SnapshotTable = ({ rows, onOpen, testid, empty = "No symbols", showDerivs = true }) => (
  <div className="scroll-thin overflow-x-auto" data-testid={testid}>
    <table className="w-full min-w-[860px] border-collapse">
      <thead className="border-b border-slate-800 bg-slate-900/60">
        <tr>
          <TH>Symbol</TH><TH right>LTP</TH><TH right>Chg</TH><TH right>Chg %</TH><TH right>Open</TH><TH right>High</TH>
          <TH right>Low</TH><TH right>Prev C</TH><TH right>Volume</TH>{showDerivs && <TH right>OI</TH>}<TH right>Bid / Ask</TH>
          <TH right>Updated</TH><TH>Status</TH>
        </tr>
      </thead>
      <tbody>
        {(rows || []).map((r) => (
          <tr key={r.instrument_token} data-testid={`row-${slug(r.key)}`} onClick={() => onOpen(r)}
            className="cursor-pointer border-b border-slate-800/60 transition-colors hover:bg-slate-800/40">
            <td className="px-3 py-2">
              <div className="font-mono text-[13px] font-medium text-slate-100">{r.tradingsymbol}</div>
              <div className="font-mono text-[10px] text-slate-600">{r.exchange}{r.expiry ? ` · ${r.expiry}` : ""}</div>
            </td>
            <td className="px-3 py-2 text-right"><LtpCell value={r.ltp} className="text-[13px] font-semibold text-slate-100" testid={`ltp-${slug(r.key)}`} /></td>
            <td className={`num px-3 py-2 text-right text-xs ${tone(r.change)}`}>{fmtChg(r.change)}</td>
            <td className={`num px-3 py-2 text-right text-xs font-semibold ${tone(r.change_pct)}`}>{fmtPct(r.change_pct)}</td>
            <td className="num px-3 py-2 text-right text-xs text-slate-400">{fmt(r.ohlc?.open)}</td>
            <td className="num px-3 py-2 text-right text-xs text-slate-400">{fmt(r.ohlc?.high)}</td>
            <td className="num px-3 py-2 text-right text-xs text-slate-400">{fmt(r.ohlc?.low)}</td>
            <td className="num px-3 py-2 text-right text-xs text-slate-500">{fmt(r.ohlc?.close)}</td>
            <td className="num px-3 py-2 text-right text-xs text-slate-300">{fmtQty(r.volume)}</td>
            {showDerivs && <td className="num px-3 py-2 text-right text-xs text-slate-300">{fmtQty(r.oi)}</td>}
            <td className="num px-3 py-2 text-right text-[11px] text-slate-400">
              {r.best_bid ? `${fmt(r.best_bid)} / ${fmt(r.best_ask)}` : r.total_buy_qty ? `${fmtQty(r.total_buy_qty)} / ${fmtQty(r.total_sell_qty)}` : "—"}
            </td>
            <td className="num px-3 py-2 text-right text-[11px] text-slate-500">{fmtTime(r.last_update)}</td>
            <td className="px-3 py-2"><StatusBadge status={r.status === "live" && r.source === "simulated" ? "simulated" : r.status} label={r.status === "live" && r.source === "simulated" ? "SIM" : undefined} testid={`status-${slug(r.key)}`} /></td>
          </tr>
        ))}
      </tbody>
    </table>
    {rows && rows.length === 0 && <div className="py-10 text-center text-xs text-slate-500">{empty}</div>}
    {!rows && <div className="m-3 h-40 animate-pulse rounded bg-slate-900" />}
  </div>
);
